export function buildOAuthRedirectUri(provider: 'google' | 'facebook'): string {
  const base = import.meta.env.VITE_OAUTH_REDIRECT_BASE ?? window.location.origin;
  return `${base.replace(/\/$/, '')}/oauth/${provider}/callback`;
}

type QueryValue = string | number | boolean | null | undefined;

export function withQuery(path: string, params: Record<string, QueryValue>): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null) continue;
    usp.set(k, String(v));
  }
  const qs = usp.toString();
  return qs ? `${path}?${qs}` : path;
}
